import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=7b15ae18&scoped=true"
import script from "./companyInfo.vue?vue&type=script&lang=ts"
export * from "./companyInfo.vue?vue&type=script&lang=ts"
import style0 from "./companyInfo.vue?vue&type=style&index=0&id=7b15ae18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b15ae18",
  null
  
)

export default component.exports